import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Label from "../../components/Label/Label";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import TextField from "../../components/TextField/TextField";
import HookForm from "../../components/HookForm/HookForm";
import SearchBox from "../../components/SearchBox/SearchBox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PolicyImg from "../../assests/img/policy.png";
import { Dropdown, Form } from "react-bootstrap";
import "./DetailsPage.scss";
import Dropdownx from "../../components/Dropdown/Dropdownx";
import Header from "../../components/Header/Header";
import ModalPopup from "../../components/ModalPopup/ModalPopup";
import Footer from "../../components/Footer/Footer";
import CareerAdminTab from "../../components/CareerAdminTab/CareerAdminTab";
import BlogAdminTab from "../../components/BlogAdminTab/BlogAdminTab";
import CaseStudyAdminTab from "../../components/CaseStudyAdminTab/CaseStudyAdminTab";
import CertificateAdminTab from "../../components/CertificateAdminTab/CertificateAdminTab";
import MeetingAdminTab from "../../components/MeetingAdminTab/MeetingAdminTab";
import ManagementAdminTab from "../../components/ManagementAdminTab/ManagementAdminTab";
import CaptionPublishingAdminTab from "../../components/CaptionPublishingAdminTab/CaptionPublishingAdminTab";
import AboutUsAdminTab from "../../components/AboutUsAdminTab/AboutUsAdminTab";
import PrivacyPolicyContent from "../../components/PrivacyPolicyContent/PrivacyPolicyContent";
import OopsImg from "../../assests/img/oops.png";
import {
  buildPolicyUploadPayload,
  normalizePolicyDisplay,
  SAMPLE_POLICY_JSON,
  validatePolicyJson,
} from "../../util/policyHelpers";
import { useDispatch, useSelector } from "react-redux";
import { getDetailsPageAction } from "../../reduxThings/slices/DigipankSlices";
import { fetchContactList } from "../../services/contactApi";
import {
  createHoliday,
  deleteHoliday,
  fetchHolidayList,
  HOLIDAY_TYPE_OPTIONS,
} from "../../services/holidayApi";
import { createFaq, deleteFaq, fetchFaqList } from "../../services/faqApi";
import { fetchPolicy, uploadPolicy } from "../../services/policyApi";
import {
  fetchTermsAndConditions,
  uploadTermsAndConditions,
} from "../../services/termsApi";
import {
  normalizeTermsDisplay,
  SAMPLE_TERMS_JSON,
  validateTermsJson,
} from "../../util/termsHelpers";
import {
  formatApiDate,
  formatDisplayDate,
  getApiErrorMessage,
  getDayName,
} from "../../services/apiClient";
import { downloadCsv } from "../../util/csvExport";
import { isAdminUser, isLoggedIn } from "../../util/auth";
import Seo from "../../components/Seo/Seo";
const loginForm = {
  title: {
    name: "email",
    validate: {
      required: {
        value: true,
      },
    },
  },
  FAQ: {
    name: "email",
    validate: {
      required: {
        value: true,
      },
    },
  },
};

const listData = [
  {
    brief:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
    answer:
      "totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam",
  },
  {
    brief:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
    answer:
      "totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam",
  },
  {
    brief:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
    answer:
      "totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam",
  },
  {
    brief:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
    answer:
      "totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam",
  },
  {
    brief:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
    answer:
      "totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam",
  },
  {
    brief:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
    answer:
      "totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam",
  },
];
const holidayList = [
  {
    date: "01-01-2022",
    day: "Sunday",
    type: "New Year",
  },
];

const dropdownItem = [
  {
    id: "1",
    value: "New Year",
  },
  {
    id: "2",
    value: "Makar Sankranti",
  },
  {
    id: "3",
    value: "Vasant Panchmi",
  },
];

const queryTable = [
  {
    Phone: "(316) 555-0116",
    Email: "felicia.reid@example.com",
    Date: "9/23/16",
  },
  {
    Phone: "(316) 555-0116",
    Email: "felicia.reid@example.com",
    Date: "9/23/16",
  },
  {
    Phone: "(316) 555-0116",
    Email: "felicia.reid@example.com",
    Date: "9/23/16",
  },
  {
    Phone: "(316) 555-0116",
    Email: "felicia.reid@example.com",
    Date: "9/23/16",
  },
];

function DetailsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [contactSearchQuery, setContactSearchQuery] = useState("");
  const [form, setLoginForm] = useState();
  const [tab, setTab] = useState("contactForm");
  const [accordion, setActiveAccordion] = useState(-1);
  const [hidemodal, setHidemodal] = useState(false);
  const [hideholidaymodal, setHideHolidaymodal] = useState(false);
  const [carousalStatus, setCarousalStatus] = useState(true);
  const [contacts, setContacts] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [policyData, setPolicyData] = useState(null);
  const [termsData, setTermsData] = useState(null);
  const [faqQuestion, setFaqQuestion] = useState("");
  const [faqAnswer, setFaqAnswer] = useState("");
  const [holidayDate, setHolidayDate] = useState(null);
  const [selectedHolidayType, setSelectedHolidayType] = useState(null);
  const [policyJsonFile, setPolicyJsonFile] = useState(null);
  const [termsJsonFile, setTermsJsonFile] = useState(null);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  const appData = useSelector(
    (e) => e.DigipankSlice?.DetailsPageState?.DetailsPageStateData,
  );

  useEffect(() => {
    dispatch(getDetailsPageAction());
  }, [dispatch]);

  useEffect(() => {
    if (!isLoggedIn() || !isAdminUser()) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  const filteredContacts = useMemo(() => {
    const query = contactSearchQuery.trim().toLowerCase();

    return contacts.filter((contact) => {
      const matchesSearch =
        !query ||
        contact.name?.toLowerCase().includes(query) ||
        contact.email?.toLowerCase().includes(query) ||
        contact.phoneNumber?.toLowerCase().includes(query) ||
        contact.serviceType?.toLowerCase().includes(query) ||
        contact.projectDescription?.toLowerCase().includes(query);

      if (!matchesSearch) {
        return false;
      }

      if (!startDate && !endDate) {
        return true;
      }

      const contactDate = contact.createdAt
        ? new Date(contact.createdAt)
        : null;

      if (!contactDate || Number.isNaN(contactDate.getTime())) {
        return true;
      }

      if (startDate && contactDate < startDate) {
        return false;
      }

      if (endDate && contactDate > endDate) {
        return false;
      }

      return true;
    });
  }, [contacts, contactSearchQuery, startDate, endDate]);

  const handleDownloadContacts = () => {
    downloadCsv(
      `contact-data-${formatApiDate(new Date())}.csv`,
      filteredContacts,
      [
        { label: "Full Name", get: (row) => row.name },
        { label: "Email", get: (row) => row.email },
        { label: "Phone", get: (row) => row.phoneNumber },
        { label: "Date", get: (row) => formatDisplayDate(row.createdAt) },
        { label: "Service", get: (row) => row.serviceType },
        { label: "Project Brief", get: (row) => row.projectDescription },
      ],
    );
  };

  const loadContacts = async () => {
    try {
      const items = await fetchContactList();
      setContacts(items);
    } catch (error) {
      console.error("Failed to load contacts", error);
    }
  };

  const loadHolidays = async () => {
    try {
      const items = await fetchHolidayList();
      setHolidays(items);
    } catch (error) {
      console.error("Failed to load holidays", error);
    }
  };

  const loadFaqs = async () => {
    try {
      const items = await fetchFaqList();
      setFaqs(items);
    } catch (error) {
      console.error("Failed to load FAQs", error);
    }
  };

  const loadPolicy = async () => {
    try {
      const policy = await fetchPolicy();
      setPolicyData(policy);
    } catch (error) {
      console.error("Failed to load policy", error);
    }
  };

  const loadTerms = async () => {
    try {
      const terms = await fetchTermsAndConditions();
      setTermsData(terms);
    } catch (error) {
      console.error("Failed to load terms and conditions", error);
    }
  };

  useEffect(() => {
    if (!appData?.Tabs) {
      return;
    }

    loadContacts();
    loadHolidays();
    loadFaqs();
    loadPolicy();
    loadTerms();
  }, [appData?.Tabs?.blog?.title]);

  const handleSaveHoliday = async () => {
    if (!holidayDate || !selectedHolidayType?.value) {
      window.alert("Please select a date and holiday type.");
      return;
    }

    setIsSaving(true);

    try {
      await createHoliday({
        date: formatApiDate(holidayDate),
        day: getDayName(holidayDate),
        name: selectedHolidayType.value,
      });
      setHideHolidaymodal(false);
      setHolidayDate(null);
      setSelectedHolidayType(null);
      await loadHolidays();
    } catch (error) {
      window.alert(getApiErrorMessage(error, "Failed to add holiday."));
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteHoliday = async (holidayId) => {
    if (!window.confirm("Delete this holiday?")) {
      return;
    }

    try {
      await deleteHoliday(holidayId);
      await loadHolidays();
    } catch (error) {
      window.alert(getApiErrorMessage(error, "Failed to delete holiday."));
    }
  };

  const handleSaveFaq = async () => {
    if (!faqQuestion.trim() || !faqAnswer.trim()) {
      window.alert("Please enter both question and answer.");
      return;
    }

    setIsSaving(true);

    try {
      await createFaq({
        question: faqQuestion.trim(),
        answer: faqAnswer.trim(),
      });
      setFaqQuestion("");
      setFaqAnswer("");
      await loadFaqs();
    } catch (error) {
      window.alert(getApiErrorMessage(error, "Failed to add FAQ."));
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteFaq = async (faqId) => {
    if (!window.confirm("Delete this FAQ?")) {
      return;
    }

    try {
      await deleteFaq(faqId);
      await loadFaqs();
    } catch (error) {
      window.alert(getApiErrorMessage(error, "Failed to delete FAQ."));
    }
  };

  const openPolicyModal = () => {
    setPolicyJsonFile(null);
    setHidemodal(true);
  };

  const handlePolicyFileChange = (event) => {
    setPolicyJsonFile(event.target.files?.[0] || null);
  };

  const handleSavePolicy = async () => {
    if (!policyJsonFile) {
      window.alert("Please select a policy JSON file.");
      return;
    }

    setIsSaving(true);

    try {
      const fileText = await policyJsonFile.text();
      const parsedPolicy = JSON.parse(fileText);

      if (!validatePolicyJson(parsedPolicy)) {
        window.alert(
          "Policy JSON must be Privacy Policy format (title, data[]) or API format (date, day, name, content).",
        );
        return;
      }

      const uploadPayload = buildPolicyUploadPayload(parsedPolicy);
      const uploadedPolicy = await uploadPolicy(uploadPayload);
      setPolicyData(uploadedPolicy);
      setHidemodal(false);
      setPolicyJsonFile(null);
      window.alert("Policy uploaded successfully.");
    } catch (error) {
      window.alert(getApiErrorMessage(error, "Failed to upload policy JSON."));
    } finally {
      setIsSaving(false);
    }
  };

  const policyDisplay = useMemo(
    () => normalizePolicyDisplay(policyData),
    [policyData],
  );

  const termsDisplay = useMemo(
    () => normalizeTermsDisplay(termsData),
    [termsData],
  );

  const openTermsModal = () => {
    setTermsJsonFile(null);
    setShowTermsModal(true);
  };

  const handleTermsFileChange = (event) => {
    setTermsJsonFile(event.target.files?.[0] || null);
  };

  const handleSaveTerms = async () => {
    if (!termsJsonFile) {
      window.alert("Please select a terms and conditions JSON file.");
      return;
    }

    setIsSaving(true);

    try {
      const fileText = await termsJsonFile.text();
      const parsedTerms = JSON.parse(fileText);

      if (!validateTermsJson(parsedTerms)) {
        window.alert(
          "Terms JSON must include title, data[], subTitle, subDesc, list[], and descriptionList[].",
        );
        return;
      }

      const uploadedTerms = await uploadTermsAndConditions(parsedTerms);
      setTermsData(uploadedTerms);
      setShowTermsModal(false);
      setTermsJsonFile(null);
      window.alert("Terms and conditions uploaded successfully.");
    } catch (error) {
      window.alert(
        getApiErrorMessage(
          error,
          "Failed to upload terms and conditions JSON.",
        ),
      );
    } finally {
      setIsSaving(false);
    }
  };

  console.log("details page", appData);
  const document = [
    {
      id: 1,
      name: "Jen Tile",
      email: "jentile@gmail.com",
      contactNumber: "91256834",
      updateAt: "12/10/2022",
      service: "Website service",
      message: "Hello this side Jen Tile I want to make a website...",
    },
    {
      id: 1,
      name: "Lynne Gwistic",
      email: "lynnegwistic@gmail.com",
      contactNumber: "91256834",
      updateAt: "12/10/2022",
      service: "Website Work",
      message: "Hello this side Lynne Gwistic I want to make a website...",
    },
    {
      id: 1,
      name: "Bea Mine",
      email: "beamine@gmail.com",
      contactNumber: "91256834",
      updateAt: "12/10/2022",
      service: "Website Work",
      message: "Hello this side Bea Mine I want to make a website...",
    },
    {
      id: 1,
      name: "C. Yasoon",
      email: "cyasoon@gmail.com",
      contactNumber: "91256834",
      updateAt: "12/10/2022",
      service: "Node JS",
      message: "Hello this side C. Yasoon I want to make a website...",
    },
    {
      id: 1,
      name: "Ben Dover",
      email: "bendover@gmail.com",
      contactNumber: "91256834",
      updateAt: "12/10/2022",
      service: "Android dev",
      message: "Hello this side Ben Dover I want to make a website...",
    },
  ];
  function toggleAccordion(index) {
    setActiveAccordion(index);
  }
  const handleTab = (event) => {
    if (event === "contactForm") {
      setTab("contactForm");
    } else {
      setTab("query");
    }
  };
  const onFormSubmit = () => {};
  // const api =
  //   "https://9md76gcnig.execute-api.us-east-1.amazonaws.com/development/queries";
  // useEffect(() => {
  //   axios
  //     .get(api, {
  //       headers: {
  //         Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJjYzBkOTA3Yi1hMGExLTQ0YjUtYWRiZC04ZmNlODFkNWUzYzgiLCJyb2wiOlsiVVNFUiIsIkFETUlOIl0sImlhdCI6MTY1MzYyOTQ5NCwiZXhwIjoxNjU0MjM0Mjk0fQ.CxLa3UESgBJVaSouxfapFe6vI7bx1X7gMGJ8Oygyq4c"}`,
  //       },
  //     })
  //     .then((res) => {
  //       setCrtficte(res.data.items);
  //     });
  // }, []);
  // console.log(crtficte);
  return appData?.Tabs?.blog?.title === "Blog" ? (
    <div className="blog_Page">
      <Seo title="Admin Dashboard" path="/detailspage" noindex />
      <div className="desktop_Details">
        <Header handleClick={handleClick} />
        <div className="blog_Main">
          <Tabs
            defaultActiveKey="blog"
            id="uncontrolled-tab-example"
            className="tab_Main_Section"
          >
            <Tab eventKey="blog" title={appData?.Tabs?.blog?.title}>
              <BlogAdminTab labels={appData?.Tabs?.blog} />
            </Tab>
            <Tab eventKey="contact" title={appData.Tabs.contactForm.title}>
              <div className="common_Header">
                <div className="search_Box">
                  <SearchBox
                    placeholder={appData.Tabs.contactForm.searchPlaceHolder}
                    onChange={(event) =>
                      setContactSearchQuery(event.target.value)
                    }
                  />
                </div>
                <div className="right_Section">
                  <div className="date_Inline">
                    <div className="date_Section">
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText={
                          appData.Tabs.contactForm.startPlaceHolder
                        }
                      />
                      <i className="icon-calendar iconCalendar"></i>
                    </div>
                    <div className="date_Section marginR">
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText={
                          appData.Tabs.contactForm.endPlaceHolder
                        }
                      />
                      <i className="icon-calendar iconCalendar"></i>
                    </div>
                  </div>
                  <CustomButton
                    title={appData.Tabs.contactForm.downloadBtn}
                    onClick={handleDownloadContacts}
                  ></CustomButton>
                </div>
              </div>
              <div className="tab_Button">
                <CustomButton
                  title={appData.Tabs.contactForm.contactFormBtn}
                  onClick={() => handleTab("contactForm")}
                />
                <CustomButton
                  title={appData.Tabs.contactForm.queryBtn}
                  onClick={() => handleTab("query")}
                />
              </div>
              {tab === "contactForm" && (
                <div className="contact_Table">
                  <ul className="header">
                    <li className="combine">
                      <ul className="combine_Li">
                        <li className="name">
                          {" "}
                          {appData.Tabs.contactForm.contactFormTable.fullName}
                        </li>
                        <li className="email">
                          {appData.Tabs.contactForm.contactFormTable.email}
                        </li>
                        <li className="phone">
                          {appData.Tabs.contactForm.contactFormTable.phone}
                        </li>
                      </ul>
                    </li>
                    <li className="date">
                      {appData.Tabs.contactForm.contactFormTable.date}
                    </li>
                    <li className="service">
                      {appData.Tabs.contactForm.contactFormTable.service}
                    </li>
                    <li className="project">
                      {appData.Tabs.contactForm.contactFormTable.projectBrief}
                    </li>
                  </ul>
                  <div>
                    {filteredContacts.map((element) => {
                      return (
                        <ul className="data_List" key={element.contactId}>
                          <li className="combine">
                            <ul className="combine_Li">
                              <li className="name">{element.name}</li>
                              <li className="email">{element.email}</li>
                              <li className="phone">{element.phoneNumber}</li>
                            </ul>
                          </li>
                          <li className="date">
                            {formatDisplayDate(element.createdAt)}
                          </li>
                          <li className="service">{element.serviceType}</li>
                          <li className="project">
                            {element.projectDescription}
                          </li>
                        </ul>
                      );
                    })}
                  </div>
                </div>
              )}

              {tab === "query" && (
                <div className="query">
                  {/* {crtficte.map((tableData) => {
                  return ( */}
                  <div className="query_card d-flex">
                    {appData.Tabs.contactForm.queryData.map((element) => {
                      return (
                        <div className="card_Section" key={element.id}>
                          <div className="content_section">
                            <div className="d-flex align-items-center">
                              <span className="">{element.phoneKey}</span>
                              <Label
                                title={element.phone}
                                className="pb-0 paddingLedt"
                              ></Label>
                            </div>
                            <div className="d-flex align-items-center">
                              <span className="">{element.emailKey}</span>
                              <Label
                                title={element.email}
                                className="pb-0 paddingLedt"
                              ></Label>
                            </div>
                            <div className="d-flex align-items-center">
                              <span className="">{element.phoneKey}</span>
                              <Label
                                title={element.phone}
                                className="pb-0 paddingLedt"
                              ></Label>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </Tab>
            <Tab eventKey="management" title="Management">
              <ManagementAdminTab labels={appData?.Tabs?.management} />
            </Tab>
            <Tab eventKey="policy" title={appData.Tabs.policy.title}>
              <div className="privacy_page">
                <div className="policy_Admin">
                  <Label title="Policy Management" className="heading" />
                  <div className="policy_Button">
                    <CustomButton
                      title={
                        appData.Tabs.policy.editBtn || "Upload Policy JSON"
                      }
                      onClick={openPolicyModal}
                    />
                  </div>
                  {policyData?.updatedAt && (
                    <Label
                      title={`Last updated: ${formatDisplayDate(policyData.updatedAt)}`}
                      className="policy_Updated"
                    />
                  )}
                  {policyDisplay?.isLocalFallback && (
                    <Label
                      title="Showing local sample policy (API unavailable or no data yet)."
                      className="policy_Fallback_Notice"
                    />
                  )}
                </div>
                <div className="policy_Preview">
                  <Label title="Preview" className="preview_Heading" />
                  <PrivacyPolicyContent
                    policy={policyDisplay}
                    showBanner
                    bannerImage={PolicyImg}
                  />
                </div>
              </div>
            </Tab>
            <Tab
              eventKey="certificate"
              title={appData.Tabs.certificate?.title || "Certificates"}
            >
              <CertificateAdminTab labels={appData.Tabs.certificate} />
            </Tab>
            <Tab
              eventKey="terms"
              title={appData.Tabs.terms?.title || "Terms & Conditions"}
            >
              <div className="privacy_page">
                <div className="policy_Admin">
                  <Label
                    title="Terms & Conditions Management"
                    className="heading"
                  />
                  <div className="policy_Button">
                    <CustomButton
                      title={appData.Tabs.terms?.editBtn || "Upload Terms JSON"}
                      onClick={openTermsModal}
                    />
                  </div>
                  {termsData?.updatedAt && (
                    <Label
                      title={`Last updated: ${formatDisplayDate(termsData.updatedAt)}`}
                      className="policy_Updated"
                    />
                  )}
                  {termsDisplay?.isLocalFallback && (
                    <Label
                      title="Showing local sample terms (API unavailable or no data yet)."
                      className="policy_Fallback_Notice"
                    />
                  )}
                </div>
                <div className="policy_Preview">
                  <Label title="Preview" className="preview_Heading" />
                  <PrivacyPolicyContent policy={termsDisplay} />
                </div>
              </div>
            </Tab>
            <Tab
              eventKey="aboutus"
              title={appData.Tabs.aboutUs?.title || "About Us"}
            >
              <AboutUsAdminTab labels={appData.Tabs.aboutUs} />
            </Tab>
            <Tab eventKey="holidaylist" title="Holiday List">
              <div className="right_Section holidayList">
                <CustomButton
                  title={appData.Tabs.holidayList.addBtn}
                  onClick={() => setHideHolidaymodal(!hideholidaymodal)}
                ></CustomButton>
              </div>
              <div className="contact_Table holiday_Table">
                <ul className="header">
                  <li className="combine">
                    {appData.Tabs.holidayList.tableHead.date}
                  </li>
                  <li className="date">
                    {appData.Tabs.holidayList.tableHead.day}
                  </li>
                  <li className="service">
                    {appData.Tabs.holidayList.tableHead.holidayType}
                  </li>
                  <li className="project">
                    {appData.Tabs.holidayList.tableHead.action}
                  </li>
                </ul>
                {holidays.map((element) => {
                  return (
                    <ul className="data_List" key={element.holidayId}>
                      <li className="combine">{element.date}</li>
                      <li className="date">{element.day}</li>
                      <li className="service">{element.name}</li>
                      <li className="project">
                        <span
                          className="icon-delete cursorP"
                          onClick={() => handleDeleteHoliday(element.holidayId)}
                        ></span>
                      </li>
                    </ul>
                  );
                })}
              </div>
            </Tab>
            <Tab eventKey="faq" title={appData.Tabs.faq.title}>
              <div className="faq_Main">
                <CustomButton
                  title={appData.Tabs.faq.addBtn}
                  onClick={handleSaveFaq}
                ></CustomButton>
                <div className="accordion_Main">
                  {/* Edit FAQ */}
                  <div className="upload_Section ">
                    <div className="content_Section add_FAQ">
                      <div className="form1">
                        <input
                          className="form-control mb-3"
                          type="text"
                          value={faqQuestion}
                          onChange={(event) =>
                            setFaqQuestion(event.target.value)
                          }
                          placeholder={appData.Tabs.faq.faqTitlePlaceholder}
                        />
                        <textarea
                          className="form-control heightText"
                          rows="5"
                          value={faqAnswer}
                          onChange={(event) => setFaqAnswer(event.target.value)}
                          placeholder={appData.Tabs.faq.faqAnswer}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="faqlist" title={appData.Tabs.faqListing.title}>
              <div className="faq_List">
                <div className="update__faq">
                  <CustomButton
                    title={appData.Tabs.faqListing.updateBtn}
                  ></CustomButton>
                </div>
                <div className="accordion__Block">
                  <div className="accordion__faq">
                    {faqs.map((item, index) => (
                      <div
                        key={item.faqId || index}
                        onClick={() => toggleAccordion(item.faqId || index)}
                      >
                        <div className="accordion__Faq-heading">
                          <div className="accordion__Icon">
                            {accordion === (item.faqId || index) ? (
                              <>
                                <span className="vertical">
                                  {" "}
                                  <span className="downArrow">◉</span>
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="vertical">
                                  {" "}
                                  <span className="downArrow">▼</span>
                                </span>
                              </>
                            )}
                          </div>
                          <div
                            className={
                              accordion === (item.faqId || index)
                                ? "active"
                                : ""
                            }
                          >
                            {item.question}
                          </div>
                          <span
                            className="icon-delete cursorP"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleDeleteFaq(item.faqId);
                            }}
                          ></span>
                        </div>

                        <div className="accordion__Answer">
                          <div
                            className={
                              accordion === (item.faqId || index)
                                ? "active"
                                : "inactive"
                            }
                          >
                            {item.answer}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="accordion__Dots">
                    <Dropdownx />
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="casestudy" title="Case Study">
              <CaseStudyAdminTab />
            </Tab>
            <Tab eventKey="career" title="Career">
              <CareerAdminTab />
            </Tab>
            <Tab eventKey="captionPublishing" title="Caption Publishing">
              <CaptionPublishingAdminTab />
            </Tab>
            <Tab
              eventKey="meeting"
              title={appData.Tabs.meeting?.title || "Meeting"}
            >
              <MeetingAdminTab labels={appData.Tabs.meeting} />
            </Tab>
          </Tabs>
        </div>
        <ModalPopup
          showModal={hidemodal}
          onHide={() => setHidemodal(false)}
          onHideClick={() => setHidemodal(false)}
          onButtonClick={handleSavePolicy}
          headerTitle="Upload Policy JSON"
          buttonTitle={isSaving ? "Uploading..." : "Upload Policy JSON"}
        >
          <div className="inner_Modal">
            <Form.Group controlId="policyJsonUpload">
              <Form.Label>Select policy JSON file</Form.Label>
              <Form.Control
                type="file"
                accept=".json,application/json"
                onChange={handlePolicyFileChange}
              />
            </Form.Group>
            <details className="policy_Sample_Block">
              <summary>View sample policy JSON</summary>
              <pre>{SAMPLE_POLICY_JSON}</pre>
            </details>
            {policyJsonFile && (
              <Label
                title={`Selected: ${policyJsonFile.name}`}
                className="pt-2"
              />
            )}
          </div>
        </ModalPopup>
        <ModalPopup
          showModal={showTermsModal}
          onHide={() => setShowTermsModal(false)}
          onHideClick={() => setShowTermsModal(false)}
          onButtonClick={handleSaveTerms}
          headerTitle="Upload Terms & Conditions JSON"
          buttonTitle={isSaving ? "Uploading..." : "Upload Terms JSON"}
        >
          <div className="inner_Modal">
            <Form.Group controlId="termsJsonUpload">
              <Form.Label>Select terms and conditions JSON file</Form.Label>
              <Form.Control
                type="file"
                accept=".json,application/json"
                onChange={handleTermsFileChange}
              />
            </Form.Group>
            <details className="policy_Sample_Block">
              <summary>View sample terms JSON</summary>
              <pre>{SAMPLE_TERMS_JSON}</pre>
            </details>
            {termsJsonFile && (
              <Label
                title={`Selected: ${termsJsonFile.name}`}
                className="pt-2"
              />
            )}
          </div>
        </ModalPopup>
        <ModalPopup
          showModal={hideholidaymodal}
          onHide={() => setHideHolidaymodal(false)}
          onHideClick={() => setHideHolidaymodal(false)}
          onButtonClick={handleSaveHoliday}
          headerTitle={appData.Tabs.holidayList.addHolidayModal.addPolicy}
          buttonTitle={
            isSaving
              ? "Saving..."
              : appData.Tabs.holidayList.addHolidayModal.addBtn
          }
        >
          <div className="holiday_Modal">
            <div className="date_Section">
              <DatePicker
                selected={holidayDate}
                onChange={(date) => setHolidayDate(date)}
                placeholderText={
                  appData.Tabs.holidayList.addHolidayModal.selectDatePlaceholder
                }
              />
              <i className="icon-calendar iconCalendar"></i>
            </div>
            <CustomDropdown
              dropDownItems={HOLIDAY_TYPE_OPTIONS}
              placeholder="Select Holiday Type"
              selectedValue={selectedHolidayType}
              onSelect={(selected) => setSelectedHolidayType(selected)}
            ></CustomDropdown>
          </div>
        </ModalPopup>
        <Footer />
      </div>
      <div className="responsive_Page">
        <img
          src={OopsImg}
          alt="This page is only available on desktop and laptop devices"
        />
      </div>
    </div>
  ) : (
    React.createElement(
      "div",
      { className: "ElseBlock" },
      React.createElement(
        "h1",
        {},
        <div className="loader-div">
          <div className="loader">
            <lottie-player
              autoplay
              loop
              src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
            ></lottie-player>
          </div>
        </div>,
      ),
    )
  );
}

export default DetailsPage;
